export const STATIC_ROUTES = {
  REDIRECT_PATH_AFTER_LOGIN: '/schedulinkRedirectPath',
  TERMS_OF_SERVICE_URL: 'https://schedulink.io/terms-of-service',
  PRIVACY_POLICY_URL: 'https://schedulink.io/privacy-policy',
  HELP_CENTER_URL: 'https://schedulink.gitbook.io/help-center',
};

export const ROUTE_PATHS = {
  NOT_FOUND: '*',
  DASHBOARD: '/',
  ACCOUNTS: 'accounts',
  ACCOUNT_ITEM: 'accounts/:uuid',
  CONTACTS: 'contacts',
  CONTACT_ITEM: 'contacts/:uuid',
  EMPLOYEES: 'employees',
  SCHEDULING: 'scheduling',
  EMPLOYEE_ITEM: 'employees/:uuid',
  EVENTS: 'events',
  EVENTS_CALENDAR: 'events/calendar',
  EVENTS_TABLE: 'events/table',
  EVENT_ITEM: 'events/:uuid',
  TASKS: 'tasks',
  TASK_ITEM: 'tasks/:uuid',
  USER_SETTINGS: 'user-settings',
  PREFERENCES: 'preferences',
  ORGANIZATION: 'organization',
  INTEGRATIONS: 'integrations',
  USER_ROLES: 'user-roles',
  UER_ROLE_ITEM: 'user-roles/:uuid',
  OAUTH_REDIRECT_GOOGLE: 'oauth2redirect-google',
  OAUTH_CALLBACK_GOOGLE: 'oauth2callback-google',
  OAUTH_REDIRECT_OUTLOOK: 'oauth2redirect-outlook',
  OAUTH_CALLBACK_OUTLOOK: 'oauth2callback-outlook',
  EVENT_TEMPLATES: 'event-templates',
  EVENT_TEMPLATE_ITEM: 'event-templates/:uuid',
  TASK_TEMPLATES: 'task-templates',
  TASK_TEMPLATE_ITEM: 'task-templates/:uuid',
  ACCOUNT_TEMPLATES: 'account-templates',
  ACCOUNT_TEMPLATE_ITEM: 'account-templates/:uuid',
  CONTACT_TEMPLATES: 'contact-templates',
  CONTACT_TEMPLATE_ITEM: 'contact-templates/:uuid',
  EMPLOYEE_TEMPLATES: 'employee-templates',
  EMPLOYEE_TEMPLATE_ITEM: 'employee-templates/:uuid',
  FORM_TEMPLATES: 'form-templates',
  FORM_TEMPLATE_ITEM: 'form-templates/:uuid',
  FORM_SUBMISSION_ITEM: 'form-submissions/:uuid',
  FORM_PREVIEW_ITEM: 'form-previews/:uuid',
  EMAIL_TEMPLATES: 'email-templates',
  EMAIL_TEMPLATE_ITEM: 'email-templates/:uuid',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:uuid',
  SIGN_UP: '/sign-up/:uuid',
  LOGIN: '/login',
  CREATE_ACCOUNT: '/create-account',
  FORM: '/form',
  FORM_AUTHORIZE: '/form/get-otp/:uuid',
  FORM_AUTHENTICATE: '/form/authenticate/:uuid',
  FORM_SUBMIT: '/form/submit/:uuid',
  FORM_SUCCESS: '/form/success/:uuid',
};
